import { ApiRequest, ShowLoader } from "GlobalFunctions";
import { validateAndApplyCoupon } from "./couponValidator";

export default function Coupons(getTaxes: () => Promise<void>) {


    // Read from localStorage instead of summary
    const subscription = JSON.parse(localStorage.getItem('subscription') || '{}');
    

    if (subscription.coupon_id && Number(subscription.coupon_id) != 0) {
        hideCouponContainer();
    }

    configCoupon(getTaxes)
    return null
}

/*=============================
SET SUMMARY
=============================*/
const configCoupon = async (getTaxes: () => Promise<void>) => {

    /*=============================
    HIDE TOASTS pc="toast-discount-ok" and pc="toast-discount-error"
    =============================*/
    hideToasts();


    const coupon_form = document.querySelector('[pc="discount-form"]');
    if (coupon_form) {
        //get coupon input
        const coupon_input = coupon_form.querySelector('input');
        //get button
        const coupon_button = coupon_form.querySelector('[pc="discount-submit"]');

        // Only add the event listener if it hasn't been added before
        if (coupon_button && !coupon_button.hasAttribute('data-has-listener')) {
            const handleCouponSubmit = async (e: Event) => {
                hideToasts();
                e.preventDefault();
                if (coupon_input) {
                    const coupon_code = coupon_input.value;
                    if (coupon_code !== "") {
                        ShowLoader(true);
                        await ApiRequest({
                            method: 'POST',
                            url: '/coupons/validateCoupon',
                            body: { 
                                coupon_code
                            },
                            setResponse: (response: any) => {
                                
                                if (response.status === "success") {
                                    
                                    validateAndApplyCoupon(response.coupon).then((validationResult: any) => {
                                        console.log('Coupon validation result:', validationResult);
                                        if (validationResult.status === "success") {
                                            showToast("success", coupon_code);
                                            coupon_form.classList.add('hidden');

                                            // Append a new sibling div with the coupon name and a remove button
                                            const couponWrapper = coupon_form.parentElement;
                                            if (couponWrapper) {
                                                const activeCouponDiv = document.createElement('div');
                                                activeCouponDiv.setAttribute('pc', 'active-coupon');
                                                activeCouponDiv.innerHTML = `
                                                <span class='coupon-chip'>
                                                    ${coupon_code} 
                                                    <a class='remove-coupon' href="#" style="cursor: pointer; margin-left: 5px;" pc="remove-coupon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                                            <path d="M45.8,0c-0.6,0-1.1,0.2-1.5,0.6L24,21L3.6,0.7C3.2,0.2,2.7,0,2.1,0C1,0,0,1,0,2.1c0,0.6,0.2,1.1,0.6,1.5L21,24L0.7,44.4  c-0.8,0.8-0.9,2.1-0.1,3s2.1,0.9,3,0.1c0,0,0,0,0.1-0.1L24,27l20.4,20.4c0.8,0.8,2.1,0.9,3,0.1s0.9-2.1,0.1-3c0,0,0,0-0.1-0.1L27,24  L47.3,3.6c0.8-0.8,0.9-2.1,0.1-3C47,0.2,46.4,0,45.8,0z"/>
                                                        </svg>
                                                    </a>
                                                </span>
                                                `;
                                                couponWrapper.appendChild(activeCouponDiv);

                                                const removeBtn = activeCouponDiv.querySelector('[pc="remove-coupon"]');
                                                removeBtn?.addEventListener('click', () => {
                                                    removeCoupon(getTaxes);
                                                    activeCouponDiv.remove();
                                                });
                                            }

                                            // Update localStorage with the coupon details
                                            const subscription = JSON.parse(localStorage.getItem('subscription') || '{}');
                                            subscription.coupon_id = response.coupon.id;
                                            subscription.coupon_code = response.coupon.code;
                                            subscription.coupon_discount = response.coupon.discount;
                                            localStorage.setItem('subscription', JSON.stringify(subscription));
                                            
                                            
                                            /*IF CLIENT COUNTRY, STATE, CITY AND POSTAL CODE ARE FILLED, GET TAXES*/
                                            if(subscription.client && subscription.client.country != "" && subscription.client.state != "" && subscription.client.city != "" && subscription.client.postal != "" ){
                                                getTaxes()
                                            }
                                            /* IF NOT FILLED, UPDATE TOTAL PRICE WITHOUT TAXES */ 
                                            else {

                                                subscription.total_price = (parseFloat(subscription.subtotal) - parseFloat(subscription.total_discount || 0) + parseFloat(subscription.shipping_price || 0)).toFixed(2);
                                                localStorage.setItem('subscription', JSON.stringify(subscription));

                                                // --- Update popup header price fields with new total_price ---
                                                const summaryPrice = document.querySelector('[pc="summary-price"]');
                                                const recurrentAmount = document.querySelector('[pc="recurrent-amount"]');
                                                if (summaryPrice && subscription.total_price) {
                                                    summaryPrice.textContent = `$${parseFloat(subscription.total_price).toFixed(2)}`;
                                                }
                                                if (recurrentAmount && subscription.total_price) {
                                                    recurrentAmount.textContent = `$${parseFloat(subscription.total_price).toFixed(2)}`;
                                                }
                                                // -----------------------------------------------------------

                                            }

                                            

                                            // Update total price to include tax
             


                                        } else {
                                            showToast("error", coupon_code);
                                        }
                                    });
                                } else {
                                    showToast("error", coupon_code);
                                }
                            }
                        });
                        ShowLoader(false);
                    }
                }
            };
            
            // Add the event listener
            coupon_button.addEventListener("click", handleCouponSubmit);
            
            // Mark the button to prevent adding multiple listeners
            coupon_button.setAttribute('data-has-listener', 'true');
        }
    }
   
};

/*=============================
HIDE COUPON CONTAINER
=============================*/
const hideCouponContainer = () => {
    const coupon_form = document.querySelector('[pc="discount-wrapper"]');
    if (coupon_form) {
        coupon_form.classList.add('hidden');
    }
}


/*=============================
HIDE TOASTS
=============================*/
const hideToasts = () => {
    const toast_discount_ok = document.querySelector('[pc="toast-discount-ok"]');
    const toast_discount_error = document.querySelector('[pc="toast-discount-error"]');
    if (toast_discount_ok) {
        toast_discount_ok.classList.add('hidden');
    }
    if (toast_discount_error) {
        toast_discount_error.classList.add('hidden');
    }
}


const showToast = (type: string, coupon: string) => {
    const toast_discount_ok = document.querySelector('[pc="toast-discount-ok"]');
    const toast_discount_error = document.querySelector('[pc="toast-discount-error"]');
    if (type === "success") {
        if (toast_discount_ok) {
            toast_discount_ok.classList.remove('hidden');
        }
    } else {
        if (toast_discount_error) {
            toast_discount_error.classList.remove('hidden');
        }
    }
    /*=============================
    ADD INPUT VALUE TO TOAST toast-discount-code
    =============================*/
    if (type === "success") {
        const toast_container = document.querySelector('[pc="toast-discount-ok"]');
        const toast_discount_code = toast_container?.querySelector('[pc="toast-discount-code"]');
        if (toast_discount_code) {
            toast_discount_code.innerHTML = coupon;
        }
        
    }
    else{
        const toast_container = document.querySelector('[pc="toast-discount-error"]');
        const toast_discount_code = toast_container?.querySelector('[pc="toast-discount-code"]');
        if (toast_discount_code) {
            toast_discount_code.innerHTML = coupon;
        }
    }
}

/*=============================
REMOVE COUPON
=============================*/
export const removeCoupon = async (getTaxes: () => Promise<void>) => {
    console.log('Removing coupon...');
    hideToasts();
    const subscription = JSON.parse(localStorage.getItem('subscription') || '{}');

    delete subscription.coupon;
    delete subscription.coupon_id;
    delete subscription.coupon_code;
    delete subscription.coupon_discount;
    delete subscription.total_discount;

    // Remove product_discount from each product
    if (subscription.products && Array.isArray(subscription.products)) {
        subscription.products.forEach((product: any) => {
            delete product.product_discount;
        });
    }

    localStorage.setItem('subscription', JSON.stringify(subscription));

    // Recalculate total or getTaxes if address is complete
    if (subscription.client && subscription.client.country && subscription.client.state && subscription.client.city && subscription.client.postal) {
        await getTaxes();
    } else {
        console.log('No address provided, recalculating total price without taxes');
        subscription.total_price = (parseFloat(subscription.subtotal) - parseFloat(subscription.total_discount || 0) + parseFloat(subscription.shipping_price || 0)).toFixed(2);
        localStorage.setItem('subscription', JSON.stringify(subscription));

        // --- Update popup header price fields with new total_price ---
        const summaryPrice = document.querySelector('[pc="summary-price"]');
        const recurrentAmount = document.querySelector('[pc="recurrent-amount"]');
        if (summaryPrice && subscription.total_price) {
            summaryPrice.textContent = `$${parseFloat(subscription.total_price).toFixed(2)}`;
        }
        if (recurrentAmount && subscription.total_price) {
            recurrentAmount.textContent = `$${parseFloat(subscription.total_price).toFixed(2)}`;
        }
        // -----------------------------------------------------------
    }

    // Show the discount form again
    console.log('Showing discount form again');
    const coupon_form = document.querySelector('[pc="discount-form"]');
    coupon_form?.classList.remove('hidden');

    // Clear the coupon input field
    const coupon_input = coupon_form?.querySelector('input');
    if (coupon_input) {
        coupon_input.value = '';
    }
};